export const SMS_TEMPLATE = {
    REGISTER: 1,
    RETRIEVE: 2,
    AUTH: 3,
};
